import clsx from "clsx";
import styles from "./LocationMap.module.less";

export function LocationMap() {
  return (
    <svg width="1202" height="720" viewBox="0 0 601 360" xmlns="http://www.w3.org/2000/svg">
      <pattern
        id="earth_a"
        x="0"
        y="0"
        width="7.7"
        height="7.7"
        patternUnits="userSpaceOnUse"
        patternContentUnits="userSpaceOnUse"
      >
        <g fill="#5140B3" fillOpacity=".5">
          <circle cx="1" cy="1" r="1" />
          <circle cx="4.85" cy="1" r="1" />
          <g transform="translate(1.93 3.85)">
            <circle cx="-2.85" cy="1" r="1" />
            <circle cx="1" cy="1" r="1" />
            <circle cx="4.85" cy="1" r="1" />
          </g>
        </g>
      </pattern>
      <mask id="earth_b">
        <path d="M0 0h601v360H0z" />
        <g fillRule="evenodd" fill="#fff">
          <path
            d="M0 26h2l.5-1h1l.5-1h2l1-2h-.5L6 21H5l-.5-1H5l1.5-3H5l-.5-1H5l.5-1H7l.5 1H8l.5-1H8l-.5-1H8l.5-1H11l-1.5-3H13l.5-1h1l.5-1h2.5l.5 1h1l1 2h2l1 2h2.5l.5-1h.5l.5 1h.5l1.5-3h1l.5-1h2l1-2H32l-.5-1H34l.5-1h3l.5-1h1.5l.5 1h.5l.5-1h1.5l.5 1h.5l1-2h1l.5-1h2l.5-1H48l-.5-1h8L57 3h3.5l.5-1h5.5l.5 1h1l1.5 3h1l1 2H70l-1.5 3h.5l.5 1H68l-.5 1h1l-1 2h1l-.5 1h-1l-.5 1h1l-.5 1h-1l-.5 1h1L65 22h-3l-1 2h-2l-2 4h-2.5l-.5-1h-1l-.5-1h.5l.5-1H53l-.5-1h.5l.5-1H53l-.5-1h.5l.5-1H53l-.5-1h.5l.5-1H53l-.5-1h.5l.5-1H53l-.5-1H54l.5-1H54l-.5-1h.5l.5-1H52l-.5-1h-1l-1-2h.5l.5-1h-1L48 12h-1.5l1 2h-1l.5 1h1l.5 1h-1l.5 1h1l.5 1h-1l1.5 3h1.5L50 24h-1.5l1 2h-2l2 4H49l-.5 1H50l1.5 3H51l-.5 1h1l-1 2h-2l-.5 1h-2l-.5 1h-2l-.5 1h-1l-1 2h-1l-.5 1h1l-.5 1h-1l-1 2h-1l-.5 1h3l-1 2h2l-1 2H42l.5 1H45l-.5 1h-8L35 56h3l.5-1h6l1-2h.5l.5 1h.5l-1.5 3H47l.5 1h2l.5 1h1.5l-1 2H54l.5 1h1l.5 1h2.5l-1 2h1L57 68h-1l-.5 1h1l-1 2h1l-1 2h-2l-.5 1h-1l-.5 1h1L51 78h-1l-2 4h-1l-2 4h.5l1 2h-2l1.5 3h1.5l-.5 1h-1l-.5 1H44l-.5-1h-1l-2-4h.5l.5-1h-2l1-2h-1l1-2h-1l1-2h-1l2-4h-1l1-2h-1l1-2h-1l1-2H40l-1-2h-1l-2-4h-1.5l1-2h-1l1.5-3h1.5l-1-2h-2l-.5-1h-1l-1-2h-2l-.5-1h-2l-.5-1h-2l-1.5-3h-2l-2-4h.5l.5-1H19l-1.5-3h.5l.5-1h-2l1-2h-1l2-4h-1l.5-1h1l.5-1h-2l1-2H17l-1.5-3H17l.5-1h-2l1-2h-1l1-2h-5l-.5 1h-1l-.5 1h-3L6 26H3l-.5 1h-3zm35.5-16H37l-.5 1H36zm-7 3h2l-1 2H29l-1-2m9 2h1.5l-.5 1h-.5zm6 5h.5l.5 1h1.5l-.5 1h-2l-.5 1h-1zm8-13h1l.5 1h-1zM37 24h1l.5-1h.5l1 2h1l1 2h-.5L40 30h-1.5l-.5-1h-1l-1.5-3h.5zm8 1h1.5l-.5 1h-.5zM33 46h.5l.5 1h1.5L34 50h-3.5l1 2h-1l-.5-1h-1.5l1-2h-1l.5-1h1l.5-1h2zm1.5 5h3l-1 2h-3z"
            transform="matrix(3.85 0 0 3.85 0 -.96)"
          />
          <path
            d="M64.5 23h5l-1 2h.5l.5 1h-5l-1-2h.5zM79.5 7h.5l.5 1h1l1 2H82l-.5 1h1l-1 2h-1l-.5 1h-1.5L77 11h-1.5l1-2h1l.5-1h1zM89 4h3.5l1 2H92l-.5 1h1L92 8h-3l-.5 1H88l-.5-1h-1l-1-2H88zM100 2h1.5l.5 1h1l.5 1h2l.5 1h2l1 2h3.5l-1 2h2l-.5 1h3l.5-1h2.5l1 2h1.5l.5-1h1.5l-.5-1h-1l-.5-1h-.5l-.5 1h-1l1-2h-3l1.5-3h5.5l1 2H122l-.5 1h2.5l.5 1h3l.5 1h1.5l.5-1h.5l.5 1h3.5l.5-1h2l.5-1h3.5l.5 1h4l.5 1h1.5l-1 2h1l-.5 1h-2.5l2 4h-.5l-2 4h-1.5l1 2h-1l1 2h-.5l-.5 1h2l-.5 1h-1.5l1 2h-1l1 2H142l-.5 1h-.5l-.5-1h1l-3-6h1l-1-2h.5l1-2h-2.5l1 2h-.5l-.5 1h-3l-.5 1h-1l-.5 1h1l-1 2h4l-1 2h2l-1 2h2l-1 2h1l-1 2h-2l-1 2h-1l-1 2h.5l1 2h1.5l1.5-3h-.5l-1-2h1.5l.5-1h1l.5-1h1l.5-1h1l-3 6h1l-1 2h1l-.5 1h-1l-1 2h-2.5l1 2h-.5l-1 2h-1l1-2h.5l-1-2h-1l-.5-1h-1.5l1-2h-1l-1 2h.5l1 2h.5l-1 2h1l-1 2h1l-1 2h2l-.5 1h-.5l1.5 3h1.5l-1 2h2l-.5 1h-1.5l.5 1h1l1 2h3l.5 1h4l.5 1h.5l.5-1h1.5l.5 1h1l1 2h2.5l-1 2H149l-1-2h-1.5l-1 2H143l-.5-1h-1l2.5 5h1.5l-1 2h2l-1 2h1l-1 2h1l-1.5 3h-1l-.5 1h1l-.5 1h-1l-1.5 3h1l-.5 1h-1l-.5 1h-2l1-2h-.5l-1-2h-1l-2-4h-2.5l-.5 1h-5.5l-1-2h2l-2-4h.5l1-2h1l.5-1h1l.5-1h1l1-2h3.5l-1-2h-.5l-.5 1H130l-.5-1h-5l-.5-1h-1l-1-2h-2.5l1-2h-.5l-2-4h1l.5 1h1l-1-2h.5l.5-1h-.5l-.5-1h-1l-1.5-3h-1.5l-.5 1h-1l-1 2h-1.5l2 4h-.5l-.5 1H111l-1-2h-1.5l1-2h-2l1-2h-.5l-1-2h-1l-1-2h-2.5l-1 2h1l-.5 1h-1l-1 2h-2l-.5 1h3l-.5 1h-1l-2 4h-1l-1 2h-1l-1.5 3h.5l.5 1H95l-.5 1h-1l-1 2h1l-.5 1h-1l-1.5 3h1l-.5 1h-2.5l1 2h-2l1 2h-3l.5 1h-4l-1.5-3h1l-.5-1h-1.5l1-2H80l-1.5-3h1l-1-2h1l-.5-1h1l-3-6h1l-.5-1h-1l-.5-1h-4.5l-.5 1h-.5l-.5-1h-2l-1-2h-1.5l1-2h-2l2-4h-2l.5-1h1l.5-1h-1l.5-1h1l.5-1h1l1-2h-1l.5-1h1l.5-1h-2l1-2h-1l1.5-3h1.5l.5 1h1l-1-2h-1.5l1-2h-3l1-2h-1l.5-1h1.5l-1-2h.5l.5-1h3l-1 2h2l-1 2h2l.5-1h1.5l-.5-1h-1l-1.5-3h1l-1-2H76l1-2h1.5l-1-2h.5l1-2h2l.5-1H86l.5 1h1l.5 1h.5l.5-1h2l1.5-3h-1l1-2h-1l1.5-3h1l1-2h1.5l1 2H96l-2.5 5H95l.5 1h1l.5 1h1l-1-2h.5l1-2h-1l.5-1h3l1-2h-1l-.5 1h-1l1-2h2l.5-1h1.5l-1-2h2l-.5-1h-2l-.5-1h-2l-1-2h1l-1-2zm1.5 6h1l.5 1h-1zM92 19h3l.5 1h-3zm-11 8h1l.5 1h-1zm0 4h1l.5 1h-1zm-5.5 9h1l1 2h-1zm3.5 1h1l.5 1h-1zm7.5-3h1l1 2h-1zM81 43h3l.5 1h3l.5 1h-8l-1-2h1l.5 1h1zm9-4h1l.5 1h-1zm26.5 15h1l1 2h-.5l-.5 1h-1l.5-1h.5zm10-4h3l1 2h-1l1 2h-1l1 2h-2l1 2H128l-1 2h-1l.5-1h-1l-1 2h.5l.5 1h-1l-1-2h1l-1-2h.5l.5-1h1l1-2h-1l1-2h-1l.5-1h1.5zm3.5 7h1l.5 1h-1zm1 2h2l.5 1h-2zm2 2h1l.5 1h-1zm-8 2h2l.5 1h-2zm2.5 1h2l.5 1h-2zm5 0h3l1 2h-1l-.5-1h-2zm5.5 0h.5l1 2h1.5l-1.5 3h-1l1-2h-3zm3.5-10h1l.5 1h-1zm10 14h1l.5 1h1.5l-1 2h1l-1.5 3h-.5l-.5-1h-1.5l1-2h.5l.5 1h1m0 9h2l-1 2h2l-2 4h-1l-.5 1h-1l-1.5 3h-3l1-2h-.5l-.5-1h2.5l1-2h1l1.5-3h-1zM95 67h3.5l-1 2h1l-.5 1h-1l-.5 1h1L96 74h-1.5l-.5-1h-1l-.5-1h2l-1-2h1l-1-2h2"
            transform="matrix(3.85 0 0 3.85 0 -.96)"
          />
        </g>
      </mask>
      <rect
        id="earth_mask_signal"
        className={styles.Earth_mask_signal}
        x="0"
        y="0"
        width="1"
        height="720"
        fill="#5140B3"
      />
      <rect
        width="100%"
        height="100%"
        fill="url(#earth_a)"
        mask="url(#earth_b)"
        transform="scale(.999 1.0077)"
      />
      <g filter="url(#earth_filter0_d)">
        <rect
          id="earth_point_0"
          className={styles.Earth_point_0}
          x="100"
          y="78"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint0_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_0)} cx="105" cy="83" r="10px" />
        <rect
          id="earth_point_1"
          className={styles.Earth_point_1}
          x="163"
          y="130"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint1_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_1)} cx="168" cy="135" r="10px" />
        <rect
          id="earth_point_2"
          className={styles.Earth_point_2}
          x="163"
          y="332"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint2_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_2)} cx="168" cy="337" r="10px" />
        <rect
          id="earth_point_3"
          className={styles.Earth_point_3}
          x="300"
          y="110"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint3_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_3)} cx="305" cy="115" r="10px" />
        <rect
          id="earth_point_5"
          className={styles.Earth_point_5}
          x="370"
          y="175"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint5_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_5)} cx="375" cy="180" r="10px" />
        <rect
          id="earth_point_6"
          className={styles.Earth_point_6}
          x="425"
          y="180"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint6_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_6)} cx="430" cy="185" r="10px" />
        <rect
          id="earth_point_7"
          className={styles.Earth_point_7}
          x="470"
          y="235"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint7_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_7)} cx="475" cy="240" r="10px" />
        <rect
          id="earth_point_8"
          className={styles.Earth_point_8}
          x="521"
          y="278"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint8_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_8)} cx="526" cy="283" r="10px" />
        <rect
          id="earth_point_9"
          className={styles.Earth_point_9}
          x="271"
          y="125"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint9_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_9)} cx="276" cy="130" r="10px" />
        <rect
          id="earth_point_10"
          className={styles.Earth_point_10}
          x="291"
          y="135"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint10_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_10)} cx="296" cy="140" r="10px" />
        <rect
          id="earth_point_11"
          className={styles.Earth_point_11}
          x="521"
          y="148"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint11_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_11)} cx="526" cy="153" r="10px" />
        <rect
          id="earth_point_12"
          className={styles.Earth_point_12}
          x="581"
          y="328"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint12_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_12)} cx="586" cy="333" r="10px" />
        <rect
          id="earth_point_13"
          className={styles.Earth_point_13}
          x="331"
          y="125"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint13_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_13)} cx="336" cy="130" r="10px" />
        <rect
          id="earth_point_14"
          className={styles.Earth_point_14}
          x="470"
          y="205"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint14_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_14)} cx="475" cy="210" r="10px" />
        <rect
          id="earth_point_15"
          className={styles.Earth_point_15}
          x="495"
          y="230"
          width="10"
          height="10"
          rx="5"
          fill="url(#earth_paint15_linear)"
        />
        <circle className={clsx(styles.Pulse, styles.Pulse_15)} cx="500" cy="235" r="10px" />
      </g>
      <defs>
        <filter
          id="earth_filter0_d"
          x="0"
          y="0"
          width="1202"
          height="720"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="9" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0823529 0 0 0 0 0.0823529 0 0 0 0 0.0823529 0 0 0 0.15 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <linearGradient
          id="earth_paint0_linear"
          x1="118"
          y1="132"
          x2="145.4493"
          y2="84.71432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint1_linear"
          x1="181"
          y1="184"
          x2="208.4493"
          y2="136.71432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint2_linear"
          x1="181"
          y1="386"
          x2="208.4493"
          y2="338.71432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint3_linear"
          x1="318"
          y1="164"
          x2="345.4493"
          y2="116.71432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint5_linear"
          x1="388"
          y1="229"
          x2="415.4493"
          y2="181.71432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint6_linear"
          x1="443"
          y1="234"
          x2="470.4493"
          y2="186.71432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint7_linear"
          x1="488"
          y1="289"
          x2="515.4493"
          y2="2141.71432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint8_linear"
          x1="540"
          y1="332"
          x2="566.4493"
          y2="284.71432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint9_linear"
          x1="310"
          y1="179"
          x2="336.4493"
          y2="131.71423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint10_linear"
          x1="330"
          y1="189"
          x2="356.4493"
          y2="141.71423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint11_linear"
          x1="540"
          y1="202"
          x2="566.4493"
          y2="154.71423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint12_linear"
          x1="620"
          y1="382"
          x2="646.4493"
          y2="334.71423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint13_linear"
          x1="370"
          y1="179"
          x2="396.4493"
          y2="131.71423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint14_linear"
          x1="488"
          y1="289"
          x2="515.4493"
          y2="241.71432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
        <linearGradient
          id="earth_paint15_linear"
          x1="503"
          y1="314"
          x2="540.4493"
          y2="266.71432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78F5DE" />
          <stop offset="1" stopColor="#9AF7E6" />
        </linearGradient>
      </defs>
    </svg>
  );
}
